import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { ShiftDetailsProps } from 'features/notifications/types';

import {
  convertToTimezone,
  displayFullTimeRange,
  shortDayNameMonthDayFromDate,
} from 'util/dateTime';

const ShiftDetails = ({ shift, location }: ShiftDetailsProps) => {
  const { start_at_secs, end_at_secs, role_name } = shift;
  const location_name = location?.name;
  const timezone = (location as any)?.tz_name;

  // Convert Unix seconds to location timezone (returns milliseconds)
  const startInTz = convertToTimezone(start_at_secs, timezone);
  const endInTz = convertToTimezone(end_at_secs, timezone);

  return (
    <Box column gap={2} grow={1}>
      <Text variant="bodySmBold" color="mono700">
        {shortDayNameMonthDayFromDate(startInTz)}
      </Text>
      <Box row gap={4} alignItemsCenter>
        <Text variant="bodySm" color="mono700" uppercase>
          {displayFullTimeRange(startInTz, endInTz)}
        </Text>
        {role_name && (
          <>
            <Text variant="bodySm" color="mono700">
              •
            </Text>
            <Text variant="bodySm" color="mono700">
              {role_name}
            </Text>
          </>
        )}
      </Box>
      {location_name && (
        <Text variant="bodySm" color="mono700">
          {location_name}
        </Text>
      )}
    </Box>
  );
};

export default ShiftDetails;
